type CanceledVoiceMailRecording = {
    canceled_reason?: string;
    canceled_by_name?: string;
};

export function buildCanceledLabel(voiceMailRecording?: CanceledVoiceMailRecording | null): string {
    if (!voiceMailRecording?.canceled_reason) {
        return "Canceled";
    }
    if (voiceMailRecording.canceled_reason === "archive") {
        return `Canceled (Archived by ${voiceMailRecording.canceled_by_name || "unknown"})`;
    }
    return `Canceled (${voiceMailRecording.canceled_reason.replaceAll("_", " ")})`;
}
